import Test from './Test/Test.js';

export const Components = {
    Test
};